import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PieChart, Pie, Cell, ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import type { MonthlyTrend } from "@/hooks/useClassTrialStats";

interface Props {
  success: number;
  failure: number;
  refund: number;
  inProgress: number;
  monthlyTrends: MonthlyTrend[];
}

const COLORS = ["#22c55e", "#ef4444", "#a855f7", "#f59e0b"];

export function TrialStatsCharts({ success, failure, refund, inProgress, monthlyTrends }: Props) {
  const pieData = [
    { name: "สำเร็จ", value: success },
    { name: "ไม่สำเร็จ", value: failure },
    { name: "ขอคืนเงิน", value: refund },
    { name: "ดำเนินการ", value: inProgress },
  ].filter((d) => d.value > 0);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card>
        <CardHeader><CardTitle className="text-base">สัดส่วนผลลัพธ์</CardTitle></CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={280}>
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={100} label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}>
                {pieData.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle className="text-base">แนวโน้มรายเดือน</CardTitle></CardHeader>
        <CardContent>
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={monthlyTrends}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" fontSize={12} />
              <YAxis fontSize={12} />
              <Tooltip />
              <Legend />
              <Line type="monotone" dataKey="success" name="สำเร็จ" stroke="#22c55e" strokeWidth={2} />
              <Line type="monotone" dataKey="failure" name="ไม่สำเร็จ" stroke="#ef4444" strokeWidth={2} />
              <Line type="monotone" dataKey="refund" name="ขอคืนเงิน" stroke="#a855f7" strokeWidth={2} />
              <Line type="monotone" dataKey="inProgress" name="ดำเนินการ" stroke="#f59e0b" strokeWidth={2} />
            </LineChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </div>
  );
}
